import React from 'react';
import {
    Modal,
    Text
} from '@simplybenefits/sb-ui-library';

/**
 * 
 * @returns 
 */
const BlockMemberClaimsModal = ({
    blockMemberClaims,
    open,
    onClose,
    member,
    claimsBlocked,
    loader
}) => {
    const titleButtonVerbiage = claimsBlocked ? "Unblock Claims" : "Block Claims";
    
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={titleButtonVerbiage}
            primaryButton={{
                label: titleButtonVerbiage,
                onClick: () => blockMemberClaims(!claimsBlocked)
            }}
            secondaryButton={{
                label: "Cancel",
                onClick: onClose
            }}
            loader={loader}
            medium
        >
            {
                claimsBlocked
                    ? (
                        <>
                            <Text medium>
                                Unblocking claims means that <span style={{ fontWeight: 'bold' }}>{member?.firstname}</span> will regain the ability to submit claims.
                            </Text>
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>
                                    <Text medium>
                                        This includes claims submitted by the member, claims submitted by providers, and claims submitted or adjudicated by agents.
                                    </Text>
                                </li>
                                <li>
                                    <Text medium>
                                        Any claims that were moved to a suspended status during the block will remain suspended and must be manually reviewed.
                                    </Text>
                                </li>
                                <li>
                                    <Text medium>
                                        Please contact TELUS Adjudicare separately to remove any drug claim blocks, if applicable.
                                    </Text>
                                </li>
                            </ul>
                            <Text medium>
                                Only proceed if the situation that led to the original block such as a fraud investigation, unpaid premiums, or other exceptional circumstances has been resolved. This action will take effect immediately.
                            </Text>
                        </>
                    )
                    : (
                        <>
                            <Text medium>
                                Blocking claims means <span style={{ fontWeight: 'bold' }}>{member?.firstname}</span> will not be able to submit any claims. 
                            </Text>
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>
                                    <Text medium>
                                        This includes claims submitted by the member, claims submitted by providers, and claims submitted or adjudicated by agents.
                                    </Text>
                                </li>
                                <li>
                                    <Text medium>
                                        All pending claims for this member will be set to a suspended status.
                                    </Text>
                                </li>
                                <li>
                                    <Text>
                                        Drug claims submitted via TELUS Adjudicare will continue to process unless a separate block is applied. Please contact TELUS Adjudicare directly to request a drug claim block, if applicable.
                                    </Text>
                                </li>
                            </ul>
                            <Text medium>
                                Use this option only in escalated situations such as fraud investigations, unpaid premiums, or other exceptional cases. This action will take effect immediately.
                            </Text>
                        </>
                    )
            }
        </Modal>
    );
};

export default BlockMemberClaimsModal;